import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2, Eye, EyeOff } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { useAuth } from "../context/AuthContext";

export const ChangeMyPasswordDialog = ({ open, onOpenChange }) => {
  const { changePassword } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); setShow(false); };

  const handleSave = async () => {
    if (!current) { toast.error("Saisissez votre mot de passe actuel"); return; }
    if (next.length < 6) { toast.error("Le nouveau mot de passe doit contenir au moins 6 caractères"); return; }
    if (next !== confirm) { toast.error("Les deux mots de passe ne correspondent pas"); return; }
    try {
      setSaving(true);
      await changePassword(current, next);
      toast.success("Mot de passe modifié avec succès");
      reset();
      onOpenChange(false);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur lors du changement de mot de passe");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) reset(); onOpenChange(v); }}>
      <DialogContent className="max-w-sm" aria-describedby={undefined} data-testid="my-password-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <KeyRound size={18} className="text-[#26788A]" /> Changer mon mot de passe
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div>
            <Label className="mb-1 block text-xs">Mot de passe actuel</Label>
            <Input type={show ? "text" : "password"} value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="my-current-password" />
          </div>
          <div>
            <Label className="mb-1 block text-xs">Nouveau mot de passe</Label>
            <Input type={show ? "text" : "password"} value={next} onChange={(e) => setNext(e.target.value)} data-testid="my-new-password" />
          </div>
          <div>
            <Label className="mb-1 block text-xs">Confirmer le nouveau mot de passe</Label>
            <Input type={show ? "text" : "password"} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="my-confirm-password" />
          </div>
          <button className="flex items-center gap-1.5 text-xs text-slate-500 hover:text-slate-700" onClick={() => setShow(!show)} data-testid="my-password-toggle-visibility">
            {show ? <EyeOff size={13} /> : <Eye size={13} />} {show ? "Masquer" : "Afficher"} les mots de passe
          </button>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button className="bg-[#26788A] hover:bg-[#2E8FA3] text-white" onClick={handleSave} disabled={saving} data-testid="my-password-save-btn">
            {saving && <Loader2 size={14} className="animate-spin mr-1" />} Enregistrer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ChangeMyPasswordDialog;
